import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import '../style/AboutPage.css';

export default function AboutPage() {
  return (
    <div className="AboutPage">
      <Navbar />

      <section className="AboutPage-hero" id="about-hero" aria-label="About us hero">
        <img
          className="AboutPage-heroImage"
          src={`${process.env.PUBLIC_URL}/image/tisa.jpeg`}
          alt="About Abstan Logistics"
          loading="eager"
        />
        <div className="AboutPage-heroOverlay" />
        <div className="AboutPage-heroContent">
          <p>About Us</p>
          <h1>Logistics Company in Africa</h1>
        </div>
      </section>

      <main className="AboutPage-main" aria-label="About us page content">
        <section className="AboutPage-section" id="about-who">
          <div className="AboutPage-inner">
            <p className="AboutPage-kicker">Who We are</p>
            <h2 className="AboutPage-title">ABSTAN LOGISTICS LIMITED</h2>

            <p>
              Abstan Logistics is a trusted provider of seemless, efficient, and
              innovative logistics solutions. The company is built on
              professionalism, integrity, and a commitment to simplifying global
              supply chains.
            </p>

            <p>
              Backed by directors with over 10 years of experience in the
              logistics industry, we bring deep expertise in fright management,
              customs regulations, and supply chain optimization.
            </p>

            <p>
              Strategically positioned in a key East Africa trade hub, we
              connect businesses to international markets with customized
              freight and logistics services and ensure smooth, secure, and
              cost-effective transportation for various industries.
            </p>
          </div>
        </section>

        <section className="AboutPage-section" id="about-vision">
          <div className="AboutPage-inner">
            <h2>Our Vision</h2>
            <p>
              To be a leading logistics provider in Africa and beyond,
              recognized for excellence, innovation, and seamless freight
              solutions that redefine industry standards.
            </p>
          </div>
        </section>

        <section className="AboutPage-section" id="about-mission">
          <div className="AboutPage-inner">
            <h2>Our Mission</h2>
            <p>
              To provide efficient, reliable and cost-effective logistics
              solutions that simplify supply chains and connect businesses to
              global opportunities with professionalism and integrity.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
